import React, { useEffect } from 'react';
import { ScreenMessagePanelContainer, ListView, Flexbox, formatMessage } from 'cw-ui-core';
import { injectIntl } from 'react-intl';
import { Alert, Stack } from '@mui/material';
import css from 'src/styles/App.scss';
import userCss from './Users.scss';
import NewFilterConditions from 'src/features/users/components/NewFilterConditions/NewFilterConditions';
import ListViewLoader from 'src/components/ListViewLoader/ListViewLoader';
import cx from 'classnames';
import _ from 'lodash';
import Locale from 'src/i18n';
import { PERMISSIONS } from 'src/constants';
import { checkIfUserHaveGivenPermissions } from 'src/util/Util';
import { AppTabsPanelContainer } from 'src/components/AppTabsPanelContainer';

const Users = props => {
    const {
        onDidMount,
        componentWillUnmount,
        isLoading,
        columns,
        users,
        usersFiltered,
        isRowHighlighted,
        changePage,
        pageCount,
        totalCount,
        currentPageIndex,
        pageSize,
        onRowSelected,
    } = props;

    useEffect(() => {
        onDidMount();
        return () => {
            componentWillUnmount();
        };
    }, [onDidMount]);

    const getFilterConditions = () => (
        <Flexbox column className={css.actionAndMessageContainer}>
            <NewFilterConditions disableDownloadUsers={_.isEmpty(users)} {...props} />
            <ScreenMessagePanelContainer className={css.listMessages} />
        </Flexbox>
    );

    const listViewLoader = (
        <ListViewLoader
            columns={columns.map(c => {
                return {
                    className: c.className,
                    stackCount: c.stackCount,
                };
            })}
            parentClass={userCss.usersListLoader}
        />
    );

    if (!checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_VIEW])) {
        return (
            <div className={cx(css.container, css.listViewContainer)}>
                <Stack sx={{ py: 3, px: 2 }}>
                    <Alert severity="warning">{formatMessage(Locale.youDontHavePermissionToViewUsers)}</Alert>
                </Stack>
            </div>
        );
    }

    return (
        <AppTabsPanelContainer>
            <ListView
                automationName="usersList"
                isMobileSupportInDesktop={false}
                listColumns={columns}
                listData={usersFiltered}
                isLoading={isLoading || false}
                onPageChange={changePage}
                pageCount={pageCount}
                totalCount={totalCount}
                FilterConditions={getFilterConditions()}
                isRowHighlighted={isRowHighlighted}
                onRowSelected={onRowSelected}
                isStickyHeader={false}
                listViewLoader={listViewLoader}
                pageIndex={currentPageIndex}
                pageSize={pageSize}
                defaultPageSize={pageSize}
                displayCheckBox
                autoResetSelectedRows={props.autoResetSelectedRows}
                showSelectedCount
                className={css.listView}
                noDataText={<div className={userCss.noDataMsg}>{formatMessage(Locale.noResultsFound)}</div>}
            />
        </AppTabsPanelContainer>
    );
};

export default injectIntl(Users);
